import {
  get,
  post,
  put,
  del,
} from '@/utils/request';

const url = 'course-covers';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

export function restore(id) {
  return post({
    url: `${url}/${id}`,
  });
}

export function update(id, data) {
  return put({
    url: `${url}/${id}`,
    data,
  });
}

export function destroy(id) {
  return del({
    url: `${url}/${id}`,
  });
}
